module.exports = __webpack_public_path__ + "static/media/YM46_6.8a33fead.jpg";